import { render, staticRenderFns } from "./AccountRetentionPage.vue?vue&type=template&id=8b3d3b06&scoped=true"
import script from "./AccountRetentionPage.vue?vue&type=script&lang=js"
export * from "./AccountRetentionPage.vue?vue&type=script&lang=js"
import style0 from "./AccountRetentionPage.vue?vue&type=style&index=0&id=8b3d3b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3d3b06",
  null
  
)

export default component.exports